export default "__VITE_ASSET__C4lk7tNe__"